// src/Components/TermsModal.js
import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function TermsModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>Terms of Service</h1>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Signl CRM ("the Platform"), you agree to comply with and be bound by these Terms of Service.
        </p>

        <h2>2. Description of Service</h2>
        <p>
          Signl CRM is a platform designed for real estate agents to manage contacts, create listings, analyze data, and communicate with clients.
        </p>

        <h2>3. Account Responsibilities</h2>
        <p>
          You must provide accurate information when creating your account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.
        </p>

        <h2>4. Data and Content</h2>
        <p>
          You may upload contact information, notes, financial data, and property photos. We do not sell your data. It may be used internally for platform operation and analytics.
        </p>

        <h2>5. Security</h2>
        <p>
          Signl CRM uses JWT for user authentication and secure data storage. Users may request data export or deletion by contacting support.
        </p>

        <h2>6. Prohibited Conduct</h2>
        <p>
          You agree not to scrape data, submit false listings, or spam. Violations may result in account suspension or termination.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          Signl CRM is not liable for third-party content or business outcomes resulting from use of the platform.
        </p>

        <h2>8. Modifications</h2>
        <p>
          Terms may change at any time. Continued use of the platform indicates acceptance of updated terms.
        </p>

        <h1>Privacy Policy</h1>
        <h2>1. Information We Collect</h2>
        <p>
          We collect personal data like name, email, phone, license number, and listing details for account setup and functionality.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          To provide service, personalize experience, and send account-related communications.
        </p>

        <h2>3. Data Sharing</h2>
        <p>
          We do not share your data externally unless legally required.
        </p>

        <h2>4. Security</h2>
        <p>
          We use modern security practices, but no system is completely secure.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          You may request to view, update, or delete your data.
        </p>

        <h2>6. Changes</h2>
        <p>
          Continued use after updates means you agree to the new terms.
        </p>

        <p><strong>Effective date:</strong> July 13, 2025</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TermsModal;
